export default __webpack_public_path__ + "static/media/my_profile_header_icon.17e923cc.svg";